import React from 'react';
import App from './App';
import QuestionnaireToastHost from './components/QuestionnaireToastHost';
import { QuestionnairePreviewBridge } from './features/treatment-flow/QuestionnairePreviewBridge';

export const QUESTIONNAIRE_APP_ONLY = true;

export default function RootApplication() {
  return (
    <>
      <QuestionnaireToastHost />
      <QuestionnairePreviewBridge />
      <App />
    </>
  );
}
